const Group = {
  EN: {
    header: 'Group',
    filter: {
      filterAsset: 'Filter Asset :',
      all: 'All',
      door: 'Door',
      locker: 'Locker',
      room: 'Room',
      groupName: 'Group Name',
    },
    table: {
      groupName: 'Group Name',
      asset: 'Allowed Into',
    },
    addTitle: 'Add new group',
    editTitle: 'Edit group',
    remove: 'remove',
    name: 'Group Name',
    zone: 'Zone',
    modal: {
      remove: 'Do you want to remove?',
    },
    section: {
      locker: 'Locker',
      access: 'Access',
      other: 'Other module',
    },
    listTransfer: {
      available: 'Available',
      view: 'View asset',
      open: 'Force open asset',
    },
    collapse: {
      show: 'Show useable asset',
      hide: 'Hide useable asset',
    },
    createdAt: 'Created at:',
    updatedAt: 'Updated at:',
  },
  TH: {
    header: 'กลุ่ม',
    filter: {
      filterAsset: 'แสดงอุปกรณ์ :',
      all: 'ทั้งหมด',
      door: 'ประตู',
      locker: 'ล็อกเกอร์',
      room: 'ห้อง',
      groupName: 'ชื่อกลุ่ม',
    },
    table: {
      groupName: 'ชื่อกลุ่ม',
      asset: 'อนุญาตให้เข้า',
    },
    addTitle: 'สร้างกลุ่มใหม่',
    editTitle: 'แก้ไขกลุ่ม',
    remove: 'ลบกลุ่ม',
    name: 'ชื่อกลุ่ม',
    zone: 'โซน',
    modal: {
      remove: 'ต้องการที่จะลบกลุ่มนี้ใช่ไหม',
    },
    section: {
      locker: 'ล็อกเกอร์',
      access: 'อุปกรณ์',
      other: 'อุปกรณ์อื่นๆ',
    },
    listTransfer: {
      available: 'อุปกรณ์ที่พร้อมใช้งาน',
      view: 'อุปกรณ์ที่สามารถมองเห็น',
      open: 'อุปกรณ์ที่สามารถบังคับใช้ได้',
    },
    collapse: {
      show: 'แสดงอุปกรณ์ที่ใช้ได้',
      hide: 'ซ่อนอุปกรณ์ที่ใช้ได้',
    },
    createdAt: 'ถูกสร้าง:',
    updatedAt: 'ถูกอัพเดท:',
  },
};
export default Group;
